export default "/images/vendor/flag-icon-css/flags/1x1/ve.svg?ede15c2583ace31d82494dd839755767";